(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["consultation-booking"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('consultation-booking')) {
    customElements.define('consultation-booking', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.dialog = this.querySelector('dialog');
        this.embed = this.querySelector('[data-booking-embed]');
        this.status = this.querySelector('[data-booking-status]');
        this.retry = this.querySelector('[data-booking-retry]');
        this.external = this.querySelector('[data-booking-external]');
        this.querySelector('[data-booking-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.retry.addEventListener('click', () => this.initialize(), { signal });
        this.dialog.addEventListener('pointerdown', event => { this.backdropDown = event.target === this.dialog; }, { signal });
        this.dialog.addEventListener('click', event => { if (this.backdropDown && event.target === this.dialog) this.dialog.close(); }, { signal });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('amanjeda-booking-open');
          this.invoker?.focus({ preventScroll: true });
        }, { signal });
        window.addEventListener('message', event => {
          const iframe = this.embed.querySelector('iframe');
          if (event.origin !== 'https://calendly.com' || !iframe || event.source !== iframe.contentWindow) return;
          if (event.data?.event === 'calendly.event_type_viewed') this.ready();
        }, { signal });
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort(); this.controller = null;
        clearTimeout(this.readyTimer);
      }

      bookingUrl(value) {
        const url = new URL(value);
        if (url.origin !== 'https://calendly.com' || url.username || url.password) throw new Error('Invalid booking URL');
        url.searchParams.set('hide_event_type_details', '1');
        url.searchParams.set('hide_gdpr_banner', '1');
        url.searchParams.set('background_color', 'ffffff');
        url.searchParams.set('text_color', '1c1c1c');
        url.searchParams.set('primary_color', '1c1c1c');
        return url.href;
      }

      open(link) {
        if (this.dialog.open) return;
        this.invoker = link;
        this.external.href = link.href;
        this.dialog.showModal();
        document.documentElement.classList.add('amanjeda-booking-open');
        this.initialize();
      }

      async loadCalendly() {
        if (window.Calendly?.initInlineWidget) return;
        const Component = this.constructor;
        if (!Component.loader) {
          Component.loader = new Promise((resolve, reject) => {
            let script = document.getElementById('calendly-widget-js');
            const done = () => { cleanup(); resolve(); };
            const fail = () => { cleanup(); script?.remove(); reject(new Error('Booking unavailable')); };
            const cleanup = () => { clearTimeout(timeout); script?.removeEventListener('load', done); script?.removeEventListener('error', fail); };
            const timeout = setTimeout(fail, 10000);
            if (!script) {
              script = document.createElement('script'); script.id = 'calendly-widget-js'; script.async = true;
              script.src = 'https://assets.calendly.com/assets/external/widget.js';
              script.addEventListener('load', done); script.addEventListener('error', fail);
              document.head.appendChild(script);
            } else { script.addEventListener('load', done); script.addEventListener('error', fail); }
          }).catch(error => { Component.loader = null; throw error; });
        }
        await Component.loader;
        if (!window.Calendly?.initInlineWidget) throw new Error('Booking unavailable');
      }

      async initialize() {
        if (this.pending || this.embed.querySelector('iframe')) return;
        this.pending = true;
        this.retry.hidden = true;
        this.status.textContent = this.dataset.loading;
        this.embed.setAttribute('aria-busy', 'true');
        try {
          const url = this.bookingUrl(this.external.href);
          await this.loadCalendly();
          if (!this.isConnected) return;
          window.Calendly.initInlineWidget({ url, parentElement: this.embed, resize: true });
          const iframe = this.embed.querySelector('iframe');
          if (!iframe) throw new Error('Booking unavailable');
          iframe.title = this.dataset.frameTitle;
          iframe.addEventListener('load', () => this.ready(), { once: true, signal: this.controller.signal });
          this.readyTimer = setTimeout(() => { this.status.textContent = this.dataset.slow; this.embed.removeAttribute('aria-busy'); }, 15000);
        } catch (_) {
          this.status.textContent = this.dataset.error;
          this.retry.hidden = false;
          this.embed.removeAttribute('aria-busy');
        } finally { this.pending = false; }
      }

      ready() {
        clearTimeout(this.readyTimer);
        this.status.textContent = '';
        this.embed.removeAttribute('aria-busy');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dress-models"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dress-models')) {
    customElements.define('dress-models', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.slides = [...this.querySelectorAll('[data-model-slide]')];
        this.choices = [...this.querySelectorAll('[data-model-choice]')];
        this.navigation = this.querySelector('[data-model-navigation]');
        this.track = this.querySelector('[data-model-track]');
        this.steps = [...this.querySelectorAll('[data-model-step]')];
        this.count = this.querySelector('[data-model-count]');
        this.currentName = this.querySelector('[data-model-current-name]');
        if (!this.slides.length || this.slides.length !== this.choices.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.mobile = matchMedia('(max-width: 767px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.navigation.setAttribute('role', 'tablist');
        const syncOrientation = () => {
          this.stopModelMotion();
          this.navigation.setAttribute('aria-orientation', this.mobile.matches || this.dataset.navigation === 'top' ? 'horizontal' : 'vertical');
          this.scrollTarget = null;
          this.select(this.index ?? 0, false);
          if (!this.mobile.matches) this.track.scrollTo({ left: 0, behavior: 'instant' });
        };
        this.mobile.addEventListener('change', syncOrientation, { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.select(this.index, false);
        }, { signal });
        this.choices.forEach((choice, index) => {
          choice.setAttribute('role', 'tab');
          choice.setAttribute('aria-controls', this.slides[index].id);
          this.slides[index].setAttribute('role', 'tabpanel');
          this.slides[index].setAttribute('aria-labelledby', choice.id);
        });
        this.navigation.addEventListener('click', event => {
          const choice = event.target.closest('[data-model-choice]');
          if (!choice || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          event.preventDefault();
          this.select(Number(choice.dataset.modelChoice), true, false, this.mobile.matches && this.dataset.mobileBrowser === 'true');
        }, { signal });
        this.navigation.addEventListener('keydown', event => {
          const choice = event.target.closest('[data-model-choice]');
          const keys = this.mobile.matches || this.dataset.navigation === 'top' ? ['ArrowLeft', 'ArrowRight'] : ['ArrowUp', 'ArrowDown'];
          if (!choice || event.altKey || event.ctrlKey || event.metaKey || ![...keys, 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : (this.choices.indexOf(choice) + (event.key === keys[1] ? 1 : -1) + this.slides.length) % this.slides.length;
          this.select(index, true, false, this.mobile.matches && this.dataset.mobileBrowser === 'true');
          this.choices[index].focus({ preventScroll: true });
        }, { signal });
        this.addEventListener('click', event => {
          const fabrics = event.target.closest('[data-model-fabrics-scroll]');
          if (fabrics && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
            const target = document.getElementById('service-fabrics');
            if (target) {
              event.preventDefault();
              target.scrollIntoView({ block: 'start', behavior: this.motion.matches ? 'instant' : 'smooth' });
              if (event.detail === 0) target.focus({ preventScroll: true });
            }
          }
          const step = event.target.closest('[data-model-step]');
          if (step && this.contains(step)) {
            const direction = Number(step.dataset.modelStep);
            this.select(this.index + direction, true);
            if (step.classList?.contains('dress-models__inline-step')) {
              const selected = this.slides[this.index];
              const next = selected.querySelector(`[data-model-step="${direction}"]`);
              (next?.disabled ? selected.querySelector(`[data-model-step="${-direction}"]`) : next)?.focus({ preventScroll: true });
            }
          }
        }, { signal });
        this.track.addEventListener('scroll', () => {
          if (!this.mobile.matches || !this.track.clientWidth || this.scrollFrame || this.modelMotionFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            if (this.modelMotionFrame) return;
            if (this.scrollTarget != null) {
              if (Math.abs(this.track.scrollLeft - this.slideOffset(this.scrollTarget)) < 2) this.scrollTarget = null;
              else return;
            }
            const index = this.slides.reduce((nearest, _, i) => Math.abs(this.track.scrollLeft - this.slideOffset(i)) < Math.abs(this.track.scrollLeft - this.slideOffset(nearest)) ? i : nearest, 0);
            if (index !== this.index) this.select(index, true, true);
          });
        }, { signal, passive: true });
        for (const type of ['pointerdown', 'wheel']) this.track.addEventListener(type, () => { this.scrollTarget = null; }, { signal, passive: true });
        this.track.addEventListener('pointerdown', event => this.beginSwipe(event), { signal, passive: true });
        this.track.addEventListener('pointermove', event => this.moveSwipe(event), { signal, passive: false });
        this.track.addEventListener('pointerup', event => this.finishSwipe(event), { signal });
        this.track.addEventListener('pointercancel', event => this.finishSwipe(event, true), { signal });
        this.track.addEventListener('lostpointercapture', event => {
          // Touch images lose implicit capture when the track takes over the swipe.
          if (event.target === this.track) this.finishSwipe(event, true);
        }, { signal });
        this.track.addEventListener('dragstart', event => { if (this.mobile.matches && this.dataset.mobileBrowser === 'true') event.preventDefault(); }, { signal });
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.track.clientWidth;
          if (width !== this.trackWidth) {
            this.trackWidth = width;
            if (this.mobile.matches && width) {
              this.stopModelMotion();
              this.scrollTarget = null;
              this.track.scrollTo({ left: this.slideOffset(this.index), behavior: 'instant' });
            }
          }
        });
        this.resizeObserver.observe(this.track);
        this.dataset.ready = 'true';
        syncOrientation();
      }
      disconnectedCallback() {
        this.stopModelMotion();
        this.controller?.abort();
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
      hydrate(index, eager = false) {
        const slide = this.slides[index];
        if (!slide) return;
        const pending = slide.querySelector('template[data-model-image]');
        if (pending) {
          pending.replaceWith(pending.content);
          slide.querySelector('noscript')?.remove();
        }
        if (eager) slide.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
        slide.querySelectorAll('service-image-gallery').forEach(gallery => gallery.select?.(gallery.index || 0));
      }
      slideOffset(index) {
        return this.mobile.matches && this.dataset.mobileBrowser === 'true' ? this.slides[index].offsetLeft - this.slides[0].offsetLeft : index * this.track.clientWidth;
      }
      stopModelMotion() {
        cancelAnimationFrame(this.modelMotionFrame);
        this.modelMotionFrame = null;
        this.dataset.moving = 'false';
      }
      scrollToModel(left, animate) {
        const from = this.track.scrollLeft;
        this.stopModelMotion();
        if (!animate || Math.abs(left - from) < 1) {
          this.track.scrollTo({ left, behavior: 'instant' });
          return;
        }
        this.dataset.moving = 'true';
        const started = performance.now();
        const frame = now => {
          const progress = Math.min(1, (now - started) / 420);
          const eased = progress * progress * (3 - 2 * progress);
          this.track.scrollTo({ left: from + (left - from) * eased, behavior: 'instant' });
          if (progress < 1) this.modelMotionFrame = requestAnimationFrame(frame);
          else {
            this.modelMotionFrame = null;
            this.dataset.moving = 'false';
            this.scrollTarget = null;
          }
        };
        this.modelMotionFrame = requestAnimationFrame(frame);
      }
      beginSwipe(event) {
        if (!this.mobile.matches || this.dataset.mobileBrowser !== 'true' || event.isPrimary === false || (event.button != null && event.button !== 0) || event.target.closest('button, a, service-image-gallery:not([data-mobile-first-image="true"])')) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, time: event.timeStamp, horizontal: false };
      }
      moveSwipe(event) {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        if (!gesture.horizontal) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
          if (Math.abs(dy) >= Math.abs(dx)) { this.gesture = null; return; }
          gesture.horizontal = true;
          this.track.setPointerCapture?.(gesture.id);
        }
        event.preventDefault();
      }
      finishSwipe(event, cancelled = false) {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        this.gesture = null;
        const dx = event.clientX - gesture.x;
        const velocity = Math.abs(dx) / Math.max(1, event.timeStamp - gesture.time);
        const advance = !cancelled && gesture.horizontal && (Math.abs(dx) >= 48 || Math.abs(dx) >= 14 && velocity >= .35);
        this.select(Math.max(0, Math.min(this.slides.length - 1, this.index + (advance ? dx < 0 ? 1 : -1 : 0))), advance);
        if (this.track.hasPointerCapture?.(gesture.id)) this.track.releasePointerCapture(gesture.id);
      }
      select(index, announce, fromScroll = false, direct = false) {
        if (!Number.isInteger(index) || !this.slides[index]) return;
        this.index = index;
        this.hydrate(index, announce);
        if (this.mobile.matches) {
          this.hydrate(index - 1);
          this.hydrate(index + 1);
        }
        this.slides.forEach((slide, i) => {
          const active = i === index;
          slide.dataset.active = String(active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
          this.choices[i].dataset.active = String(active);
          this.choices[i].setAttribute('aria-selected', String(active));
          this.choices[i].tabIndex = active ? 0 : -1;
        });
        this.closest?.('suits-service')?.syncModelFilms?.(this);
        this.steps.forEach(step => { step.disabled = Number(step.dataset.modelStep) < 0 ? index === 0 : index === this.slides.length - 1; });
        if (this.count) this.count.textContent = `${index + 1} / ${this.slides.length}`;
        if (this.currentName) this.currentName.textContent = this.choices[index].textContent.trim();
        if (this.mobile.matches && !fromScroll) {
          this.scrollTarget = index;
          const animate = (announce || this.modelMotionFrame != null) && !direct && !this.motion.matches;
          if (this.dataset.mobileBrowser === 'true') this.scrollToModel(this.slideOffset(index), animate);
          else this.track.scrollTo({ left: this.slideOffset(index), behavior: animate ? 'smooth' : 'instant' });
        }
        if (this.mobile.matches && announce) {
          const choice = this.choices[index];
          this.navigation.scrollTo({ left: Math.max(0, choice.offsetLeft - (this.navigation.clientWidth - choice.offsetWidth) / 2), behavior: fromScroll || this.motion.matches ? 'instant' : 'smooth' });
        }
        if (announce) this.querySelector('[data-model-announcement]').textContent = `${index + 1} / ${this.slides.length} — ${this.choices[index].textContent.trim()}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editorial-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('editorial-carousel')) {
    customElements.define('editorial-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController(); const signal = this.controller.signal;
        this.track = this.querySelector('[data-loop-track]'); this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.variableWidth = this.dataset.variableWidth === 'true'; this.nativeTouch = this.dataset.nativeTouch === 'true'; this.mobile = matchMedia('(max-width: 767px)');
        this.addEventListener('click', event => { const button = event.target.closest('[data-loop-direction]'); if (button && this.contains(button)) this.advance(Number(button.dataset.loopDirection)); }, { signal });
        this.track.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') { this.animating = false; this.track.scrollTo({ left: this.cycleWidth + (event.key === 'End' ? (this.variableWidth ? this.itemOffsets[this.items.length - 1] : Math.max(0, this.items.length - this.columns) * this.step) : 0), behavior: 'instant' }); }
          else this.advance(event.key === 'ArrowRight' ? 1 : -1, 1);
        }, { signal });
        this.track.addEventListener('scroll', () => {
          if (this.animating && Math.abs(this.track.scrollLeft - this.targetLeft) > 1) return;
          this.animating = false;
          if (this.nativeTouch && this.mobile.matches) { this.scheduleNormalize(); return; }
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.normalize(); });
        }, { signal, passive: true });
        for (const event of ['wheel', 'pointerdown', 'touchstart']) this.track.addEventListener(event, () => { this.animating = false; }, { signal, passive: true });
        if (this.nativeTouch) {
          this.track.addEventListener('touchstart', () => { this.touching = true; clearTimeout(this.settleTimer); }, { signal, passive: true });
          for (const type of ['touchend', 'touchcancel']) this.track.addEventListener(type, () => { this.touching = false; this.scheduleNormalize(); }, { signal, passive: true });
          this.track.addEventListener('scrollend', () => { if (!this.touching) { clearTimeout(this.settleTimer); this.normalize(); } }, { signal, passive: true });
        }
        this.observer = new ResizeObserver(() => {
          if (!this.items) return;
          const columns = Number(getComputedStyle(this).getPropertyValue('--loop-columns'));
          if (columns !== this.columns || this.variableWidth) this.build(); else this.measure();
        }); this.observer.observe(this.track);
        this.setItems(Array.from(this.track.children).filter(item => !item.hasAttribute('data-loop-clone')));
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); clearTimeout(this.settleTimer); this.touching = false; if (this.frame) cancelAnimationFrame(this.frame); }
      setItems(items) { this.items = items; this.build(); }
      build() {
        this.animating = false;
        this.columns = Number(getComputedStyle(this).getPropertyValue('--loop-columns'));
        this.looping = this.items.length > this.columns;
        if (this.variableWidth) {
          const gap = parseFloat(getComputedStyle(this.track).columnGap);
          this.looping = this.items.reduce((width, item) => width + item.getBoundingClientRect().width + gap, -gap) > this.track.clientWidth;
        }
        const fragment = document.createDocumentFragment();
        const cloneCycle = () => {
          this.items.forEach(item => {
            const clone = item.cloneNode(true); clone.dataset.loopClone = ''; clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            if (clone.id) clone.removeAttribute('id');
            clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
            clone.querySelectorAll('a, button, [tabindex]').forEach(element => element.tabIndex = -1);
            fragment.append(clone);
          });
        };
        if (this.looping) cloneCycle(); this.items.forEach(item => fragment.append(item)); if (this.looping) cloneCycle();
        this.dataset.looping = String(this.looping);
        this.track.replaceChildren(fragment); this.measure();
        this.track.scrollTo({ left: this.cycleWidth, behavior: 'instant' });
        this.querySelector('[data-loop-navigation]').hidden = !this.looping; this.dataset.ready = 'true';
      }
      measure() {
        const card = this.track.firstElementChild;
        this.step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap) : 0;
        this.cycleWidth = this.looping ? this.step * this.items.length : 0;
        if (this.variableWidth && card) {
          const start = card.getBoundingClientRect().left;
          this.stops = Array.from(this.track.children, item => item.getBoundingClientRect().left - start);
          this.cycleWidth = this.looping ? this.stops[this.items.length] : 0;
          this.itemOffsets = this.stops.slice(0, this.items.length);
        }
        this.normalize();
      }
      normalize() {
        if (this.animating || !this.looping || !this.cycleWidth) return;
        if (this.nativeTouch && this.mobile.matches && this.touching) return;
        let left = this.track.scrollLeft;
        if (left < this.cycleWidth * .5) left += this.cycleWidth;
        else if (left > this.cycleWidth * 1.5) left -= this.cycleWidth;
        if (Math.abs(left - this.track.scrollLeft) > 1) this.track.scrollTo({ left, behavior: 'instant' });
      }
      scheduleNormalize() {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => { this.settleTimer = null; this.normalize(); }, 160);
      }
      advance(direction, amount = this.columns) {
        if (!this.looping) return;
        let origin = this.track.scrollLeft;
        this.targetLeft = origin + direction * this.step * amount;
        if (this.variableWidth) {
          const nearest = this.stops.reduce((best, stop, index) => Math.abs(stop - origin) < Math.abs(this.stops[best] - origin) ? index : best, 0);
          this.targetLeft = this.stops[Math.max(0, Math.min(this.stops.length - 1, nearest + direction * amount))];
        }
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        if (this.targetLeft < 0) { origin += this.cycleWidth; this.targetLeft += this.cycleWidth; }
        else if (this.targetLeft > maximum) { origin -= this.cycleWidth; this.targetLeft -= this.cycleWidth; }
        this.animating = !this.motion.matches;
        if (Math.abs(origin - this.track.scrollLeft) > 1) this.track.scrollTo({ left: origin, behavior: 'instant' });
        this.track.scrollTo({ left: this.targetLeft, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fabric-book-closing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fabric-library-return')) {
    customElements.define('fabric-library-return', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        import(this.dataset.browsingUrl).then(module => {
          if (signal.aborted) return;
          const link = this.querySelector('a');
          const library = new URL(link.href, location.origin);
          let view;
          try { view = module.readLibraryView(sessionStorage, library.href, location.origin); } catch { return; }
          if (!view) return;
          link.href = view.url;
          link.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
            try { module.writeLibraryView(sessionStorage, { ...view, returning: true }, library.href, location.origin); } catch {}
          }, { signal });
        }).catch(() => {});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["home-return-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('home-return-top')) {
    customElements.define('home-return-top', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.observer = new IntersectionObserver(entries => {
          this.hidden = entries[0].boundingClientRect.bottom > 1;
        }, { rootMargin: '-1px 0px 0px 0px', threshold: [0, .01] });
        this.bindHero = () => {
          this.observer.disconnect();
          this.hero = document.querySelector('#main_content > .shopify-section');
          this.hidden = !this.hero || this.hero.getBoundingClientRect().bottom > 1;
          if (this.hero) this.observer.observe(this.hero);
        };
        this.bindHero();
        this.querySelector('button').addEventListener('click', event => {
          if (event.detail === 0) this.hero?.querySelector('a[href], button:not([disabled]), [tabindex="0"]')?.focus({ preventScroll: true });
          window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
        for (const name of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) document.addEventListener(name, this.bindHero, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["journal-article"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('journal-content')) {
    customElements.define('journal-content', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        Array.from(this.children).forEach(block => {
          if (this.closest('.journal-reading--news') && !block.textContent.replace(/\u00a0/g, ' ').trim() && !block.querySelector('img, iframe, video, form') && !['IMG', 'IFRAME', 'VIDEO'].includes(block.tagName)) { if (!['SCRIPT', 'STYLE'].includes(block.tagName)) block.remove(); return; }
          const images = block.querySelectorAll('img');
          const films = block.querySelectorAll('iframe, video');
          if (!block.textContent.trim() && images.length && !films.length) {
            block.classList.add('journal-reading__media');
            if (images.length === 1) block.classList.add('journal-reading__media--single');
          }
          if (!block.textContent.trim() && films.length) block.classList.add('journal-reading__film');
        });
        this.querySelectorAll('iframe').forEach(frame => {
          if (!frame.title) frame.title = this.dataset.filmLabel;
          if (!frame.loading) frame.loading = 'lazy';
        });
        this.querySelectorAll('img').forEach((photo, index) => {
          if (!photo.loading) photo.loading = 'lazy';
          photo.decoding = 'async';
          if (photo.closest('a, button')) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'journal-media-button';
          button.setAttribute('aria-label', `${this.dataset.enlargeLabel} ${index + 1}`);
          photo.replaceWith(button);
          button.append(photo);
          if (this.closest('.journal-reading--news')) {
            let notice;
            const unavailable = () => {
              button.hidden = true;
              if (notice) return;
              notice = document.createElement('span'); notice.className = 'journal-media-unavailable'; notice.textContent = this.dataset.unavailableLabel; button.before(notice);
            };
            photo.addEventListener('error', unavailable, { signal });
            photo.addEventListener('load', () => { button.hidden = false; notice?.remove(); notice = null; }, { signal });
            if (photo.complete && !photo.naturalWidth) unavailable();
          }
        });
        this.dialog = document.createElement('dialog');
        this.dialog.className = 'journal-image-dialog';
        this.dialog.setAttribute('aria-label', this.dataset.enlargeLabel);
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'journal-image-dialog__close';
        close.setAttribute('aria-label', this.dataset.closeLabel);
        close.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="m2 2 14 14M2 16 16 2" stroke="currentColor"/></svg>';
        this.modalImage = document.createElement('img');
        this.dialog.append(close, this.modalImage);
        this.append(this.dialog);
        this.addEventListener('click', event => {
          const trigger = event.target.closest('.journal-media-button');
          if (!trigger || !this.contains(trigger)) return;
          const source = trigger.querySelector('img');
          this.modalImage.src = source.currentSrc || source.src;
          this.modalImage.alt = source.alt;
          this.trigger = trigger;
          this.dialog.showModal();
        }, { signal });
        close.addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          this.modalImage.removeAttribute('src');
          this.trigger?.focus({ preventScroll: true });
        }, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.dialog?.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-hover-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-hover-video')) {
    customElements.define('product-card-hover-video', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.wrapper = this.closest('.product-card--image-wrapper');
        this.video = this.querySelector('video');
        if (!this.wrapper || !this.video) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.hoverCapability = matchMedia('(hover: hover) and (pointer: fine)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = true;
        this.request = 0;
        this.wrapper.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          this.hovered = true;
          this.sync();
        }, { signal });
        this.wrapper.addEventListener('pointerleave', () => { this.hovered = false; this.stop(); }, { signal });
        this.video.addEventListener('playing', () => {
          if (this.shouldPlay()) this.dataset.playing = 'true';
          else this.stop();
        }, { signal });
        this.video.addEventListener('error', () => { this.failed = true; this.stop(); }, { signal });
        this.hoverCapability.addEventListener('change', () => this.sync(), { signal });
        this.reducedMotion.addEventListener('change', () => this.sync(), { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        this.observer = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; this.sync(); });
        this.observer.observe(this.wrapper);
        this.hovered = this.wrapper.matches(':hover');
        this.sync();
      }
      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
      shouldPlay() {
        return this.hovered && this.inView && this.hoverCapability.matches && !this.reducedMotion.matches && !navigator.connection?.saveData && !document.hidden && !this.failed;
      }
      sync() {
        if (this.shouldPlay()) this.start();
        else this.stop();
      }
      async start() {
        if (this.starting || !this.video.paused) return;
        const request = ++this.request;
        this.starting = true;
        this.video.muted = true;
        this.video.defaultMuted = true;
        if (!this.loaded) {
          for (const source of this.video.querySelectorAll('source[data-src]')) source.src = source.dataset.src;
          this.video.load();
          this.loaded = true;
        }
        try {
          await this.video.play();
          if (request === this.request && !this.shouldPlay()) this.stop();
        } catch (_) {
          if (request === this.request) this.dataset.playing = 'false';
        } finally {
          if (request === this.request) this.starting = false;
        }
      }
      stop() {
        this.request = (this.request || 0) + 1;
        this.starting = false;
        this.dataset.playing = 'false';
        if (!this.video) return;
        this.video.pause();
        try { this.video.currentTime = 0; } catch (_) {}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('.swatch--input')) return;
    const card = event.target.closest('.product-card--root[data-collection-product-url]');
    if (!card) return;

    queueMicrotask(() => {
      card.querySelectorAll('.product-card--image-wrapper, .product-card--title-link').forEach((link) => {
        const target = new URL(card.dataset.collectionProductUrl, window.location.origin);
        const current = new URL(link.href, window.location.origin);
        target.search = current.search;
        target.hash = current.hash;
        link.setAttribute('href', `${target.pathname}${target.search}${target.hash}`);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery-controls')) {
    customElements.define('product-gallery-controls', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.abort = new AbortController();
        this.firstButton = this.querySelector('[data-media-first]');
        if (this.dataset.mobile === 'true') {
          const mobileGallery = this.closest('.main-product--mobile');
          this.carousel = mobileGallery?.querySelector('product-carousel');
          this.mobileCount = mobileGallery?.querySelector('.carousel-nav-arrow--current');
          this.addEventListener('click', event => {
            if (event.target.closest('[data-media-first]')) this.carousel?.goToSlide?.(Number(this.dataset.firstMedia));
          }, { signal: this.abort.signal });
          if (this.mobileCount) {
            this.observer = new MutationObserver(() => this.update());
            this.observer.observe(this.mobileCount, { attributes: true, attributeFilter: ['data-value'] });
          }
          this.update();
          return;
        }
        const gallery = this.closest('product-media-variants');
        this.rail = gallery?.querySelector('.product-media--thumbs-wrapper');
        this.thumbs = Array.from(this.rail?.querySelectorAll('.product-media--thumb') || []);
        this.count = this.querySelector('[data-media-current]');
        if (!this.thumbs.length) return;
        this.addEventListener('click', event => {
          if (event.target.closest('[data-media-first]')) {
            const first = this.thumbs.find(thumb => thumb.dataset.id === this.dataset.firstMedia) || this.thumbs[0];
            first.click();
            return;
          }
          const button = event.target.closest('[data-media-direction]');
          if (!button) return;
          const current = this.thumbs.findIndex(thumb => thumb.dataset.active === 'true');
          const index = (Math.max(0, current) + Number(button.dataset.mediaDirection) + this.thumbs.length) % this.thumbs.length;
          this.thumbs[index].click();
        }, { signal: this.abort.signal });
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.rail, { subtree: true, attributes: true, attributeFilter: ['data-active'] });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.rail);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
      update() {
        if (this.dataset.mobile === 'true') {
          this.firstButton.disabled = this.mobileCount?.dataset.value === this.dataset.firstIndex;
          return;
        }
        const index = this.thumbs.findIndex(thumb => thumb.dataset.active === 'true');
        if (index < 0) return;
        this.count.textContent = String(index + 1);
        this.firstButton.disabled = this.thumbs[index].dataset.id === this.dataset.firstMedia;
        this.thumbs.forEach((thumb, position) => thumb.setAttribute('aria-pressed', String(position === index)));
        const railBounds = this.rail.getBoundingClientRect();
        if (!railBounds.width) return;
        const thumbBounds = this.thumbs[index].getBoundingClientRect();
        let offset = 0;
        if (thumbBounds.left < railBounds.left + 3) offset = thumbBounds.left - railBounds.left - 3;
        else if (thumbBounds.right > railBounds.right - 3) offset = thumbBounds.right - railBounds.right + 3;
        if (offset) this.rail.scrollBy({ left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-information-tabs')) {
    customElements.define('product-information-tabs', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        if (this.dataset.ready !== 'true') this.splitFabricCare();
        this.allTabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs = this.allTabs.filter(tab => !tab.hidden);
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.mtmTab = this.querySelector('[data-mtm-tab]');
        this.mtmPanel = this.querySelector('[data-mtm-panel]');
        this.mtmDisclosure = this.querySelector('[data-mtm-disclosure]');
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"], [data-mtm-panel]'));
        if (!this.allTabs.length) return;
        const options = { signal: this.abort.signal };
        this.mobile.addEventListener('change', () => this.syncLayout(), options);
        this.mtmDisclosure?.addEventListener('toggle', () => {
          if (this.mobile.matches) this.mobileMtmOpen = this.mtmDisclosure.open;
        }, options);
        this.addEventListener('click', event => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.tabs.includes(tab)) this.activate(tab, false, true);
        }, options);
        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !this.tabs.includes(tab)) return;
          let index = this.tabs.indexOf(tab);
          if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') index = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate(this.tabs[index], true);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const panel = this.panels.find(item => item.dataset.blockId === event.detail?.blockId);
          const tab = this.tabs.find(item => item.getAttribute('aria-controls') === panel?.id);
          if (tab) this.activate(tab);
        }, options);
        this.syncLayout();
        this.dataset.ready = 'true';
      }
      disconnectedCallback() { this.abort?.abort(); }
      syncLayout() {
        let selected = this.allTabs.find(tab => tab.getAttribute('aria-selected') === 'true');
        const focusedMtmContent = this.mtmPanel?.contains(document.activeElement);
        const focusedMtmTab = this.mtmTab && document.activeElement === this.mtmTab;
        if (this.mtmTab && this.mtmPanel && this.mtmDisclosure) {
          this.mtmTab.hidden = this.mobile.matches;
          this.mtmDisclosure.open = !this.mobile.matches || Boolean(this.mobileMtmOpen);
          if (this.mobile.matches) {
            this.mtmPanel.removeAttribute('role');
            this.mtmPanel.removeAttribute('aria-labelledby');
            this.mtmPanel.removeAttribute('tabindex');
          } else {
            if (focusedMtmContent) selected = this.mtmTab;
            this.mtmPanel.setAttribute('role', 'tabpanel');
            this.mtmPanel.setAttribute('aria-labelledby', this.mtmTab.id);
            this.mtmPanel.setAttribute('tabindex', '0');
          }
        }
        this.tabs = this.allTabs.filter(tab => !tab.hidden);
        this.querySelector('[role="tablist"]').hidden = !this.tabs.length;
        const active = this.tabs.includes(selected) ? selected : this.tabs.includes(this.lastInformationTab) ? this.lastInformationTab : this.tabs[0];
        if (active) this.activate(active);
        else if (this.mtmPanel) this.mtmPanel.hidden = false;
        if ((focusedMtmTab || focusedMtmContent) && this.mobile.matches) this.mtmDisclosure.querySelector('summary').focus({ preventScroll: true });
        else if (focusedMtmContent) this.mtmTab.focus({ preventScroll: true });
      }
      splitFabricCare() {
        const source = this.querySelector('[data-product-description]');
        const destination = this.querySelector('[data-fabric-content]');
        const fabricTab = this.querySelector('[data-fabric-tab]');
        if (!source || !destination || !fabricTab) return;
        const heading = Array.from(source.querySelectorAll('h2, h3, h4, h5, h6, p, strong, b, span, div')).find(item => {
          const label = item.textContent.replace(/\s+/g, ' ').trim();
          return /^(?:(?:fabric|material)\s*(?:&|and)\s*care|(?:materjal|kangas|koostis)\s*(?:&|ja)\s*hooldus)\s*:?$/i.test(label);
        });
        if (!heading) return;
        const range = document.createRange();
        range.setStartBefore(heading);
        range.setEnd(source, source.childNodes.length);
        destination.append(range.extractContents());
        fabricTab.hidden = false;
        if (!source.textContent.trim() && !source.querySelector('img, video, table')) {
          const panel = source.closest('[role="tabpanel"]');
          const tab = this.querySelector(`[aria-controls="${panel.id}"]`);
          if (tab) tab.hidden = true;
          panel.hidden = true;
        }
      }
      activate(selected, focus = false, reveal = false) {
        if (selected !== this.mtmTab) this.lastInformationTab = selected;
        this.allTabs.forEach(tab => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = !(this.mobile.matches && panel === this.mtmPanel) && panel.id !== selected.getAttribute('aria-controls'); });
        if (focus) selected.focus({ preventScroll: true });
        if (focus || (reveal && window.matchMedia('(max-width: 767px)').matches)) {
          const rail = selected.parentElement;
          const bounds = rail.getBoundingClientRect();
          const rect = selected.getBoundingClientRect();
          let left = rail.scrollLeft;
          if (rect.left < bounds.left + 2) left -= bounds.left + 2 - rect.left;
          else if (rect.right > bounds.right - 2) left += rect.right - bounds.right + 2;
          if (left !== rail.scrollLeft) {
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            rail.scrollTo({ left, behavior: focus || reducedMotion ? 'instant' : 'smooth' });
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-made-to-measure"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-tailoring')) {
    customElements.define('product-tailoring', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.bookUrl || this.loaded) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.loadSwatches();
          }
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      async loadSwatches() {
        this.loaded = true;
        try {
          const url = new URL(this.dataset.bookUrl, location.origin);
          if (url.origin !== location.origin) return;
          const response = await fetch(url.href);
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const samples = Array.from(doc.querySelectorAll('[data-fabric-source] [data-fabric-swatch]'));
          for (let i = samples.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [samples[i], samples[j]] = [samples[j], samples[i]];
          }
          const rail = this.querySelector('.product-tailoring__swatches');
          const seen = new Set();
          for (const sample of samples) {
            const source = sample.dataset.imageUrl;
            if (!source || seen.has(source)) continue;
            seen.add(source);
            const imageUrl = new URL(source, location.origin);
            if (imageUrl.protocol !== 'https:') continue;
            imageUrl.searchParams.set('width', '120');
            const link = document.createElement('a');
            link.href = url.href;
            const image = document.createElement('img');
            image.src = imageUrl.href;
            image.alt = sample.querySelector('img')?.alt || this.querySelector('.product-tailoring__book').textContent;
            image.width = 100;
            image.height = 100;
            image.loading = 'lazy';
            link.append(image);
            rail.append(link);
            if (rail.children.length === 5) break;
          }
          rail.hidden = !rail.children.length;
        } catch {}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-shipping-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('estimated-shipping-date')) {
    customElements.define('estimated-shipping-date', class extends HTMLElement {
      connectedCallback() {
        this.refreshDate = () => this.updateDate();
        this.updateDate();
        document.addEventListener('visibilitychange', this.refreshDate);
        window.addEventListener('pageshow', this.refreshDate);
        this.timer = window.setInterval(this.refreshDate, 60000);
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.refreshDate);
        window.removeEventListener('pageshow', this.refreshDate);
        window.clearInterval(this.timer);
      }

      updateDate(now = new Date()) {
        const weeks = Number(this.dataset.weeks);
        if (!Number.isInteger(weeks) || weeks < 1 || weeks > 52) return;

        const today = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Tallinn', year: 'numeric', month: 'numeric', day: 'numeric'
        }).formatToParts(now).filter(part => ['year', 'month', 'day'].includes(part.type))
          .map(part => [part.type, Number(part.value)]));
        const shippingDate = new Date(Date.UTC(today.year, today.month - 1, today.day + weeks * 7));
        const isoDate = shippingDate.toISOString().slice(0, 10);
        if (this.dataset.date === isoDate && this.dataset.initialized === 'true') return;

        const date = new Intl.DateTimeFormat(this.dataset.locale || 'en', {
          timeZone: 'UTC', month: 'long', day: 'numeric'
        }).format(shippingDate);
        this.textContent = this.dataset.message.replace('__DATE__', date);
        this.dataset.date = isoDate;
        this.dataset.initialized = 'true';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('amanjeda-size-guide')) {
    customElements.define('amanjeda-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.dialog = this.querySelector('dialog');
        this.tabs = Array.from(this.querySelectorAll('[data-guide-tab]'));
        this.compare = this.querySelector('[data-guide-compare]');
        this.optionList = this.querySelector('[data-guide-options]');
        this.root = this.closest('[data-section-id]');
        if (!this.root) return;
        this.prepareLinks();
        this.observer = new MutationObserver(() => this.prepareLinks());
        this.observer.observe(this.root, { childList: true, subtree: true });
        this.resizeObserver = new ResizeObserver(() => { if (this.dialog.open) this.highlight(this.compare?.value || ''); });
        this.querySelectorAll('[data-size-guide-table]').forEach(scroller => this.resizeObserver.observe(scroller));
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-size-guide-open]');
          if (!trigger || trigger.dataset.sizeGuideOpen !== this.dataset.productId) return;
          event.preventDefault();
          this.trigger = trigger;
          this.activeOption = trigger.dataset.sizeGuideOption;
          this.syncSelection();
          this.showTab('chart');
          if (!this.dialog.open) this.dialog.showModal();
          this.highlight(this.compare?.value || '');
        }, { signal });
        this.addEventListener('click', event => {
          if (event.target.closest('[data-guide-close]') || event.target === this.dialog) this.dialog.close();
          const tab = event.target.closest('[data-guide-tab]');
          if (tab) this.showTab(tab.dataset.guideTab);
          const unit = event.target.closest('[data-guide-unit]');
          if (unit) this.setUnit(unit.dataset.guideUnit);
          const option = event.target.closest('[data-guide-option]');
          if (option) { this.activeOption = option.dataset.guideOption; this.syncSelection(); this.highlight(this.compare?.value || ''); }
        }, { signal });
        this.compare?.addEventListener('change', () => this.highlight(this.compare.value), { signal });
        this.querySelectorAll('details').forEach(details => details.addEventListener('toggle', () => { if (details.open) this.highlight(this.compare?.value || ''); }, { signal }));
        this.addEventListener('keydown', event => {
          if (!event.target.matches('[data-guide-tab]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const current = this.tabs.indexOf(event.target);
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.showTab(this.tabs[index].dataset.guideTab);
          this.tabs[index].focus();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          const currentTrigger = this.root.querySelector(`[data-size-guide-open="${CSS.escape(this.dataset.productId)}"][data-size-guide-option="${this.activeOption}"]`);
          (currentTrigger || this.trigger)?.focus();
        }, { signal });
        window.addEventListener(`theme:product:${this.dataset.productId}:variantChanged`, () => { if (this.dialog.open) { this.syncSelection(); this.highlight(this.compare?.value || ''); } }, { signal });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.dialog?.open) this.dialog.close();
      }
      prepareLinks() {
        this.root.querySelectorAll(`.product-size-guide--root:has([data-size-guide-open="${CSS.escape(this.dataset.productId)}"])`).forEach(wrapper => {
          const option = wrapper.closest('.product-options--option');
          const header = option?.querySelector('.radios--header, .disclosure--label, .swatches--header');
          if (header) {
            let row = header.closest('.product-size-guide--header');
            if (!row) {
              row = document.createElement('div');
              row.className = 'product-size-guide--header';
              header.before(row);
              row.append(header);
            }
            if (wrapper.parentElement !== row) row.append(wrapper);
          }
          wrapper.dataset.guideReady = 'true';
        });
      }
      syncSelection() {
        const options = Array.from(this.root.querySelectorAll('.product-options--option')).filter(option => option.querySelector(`[data-size-guide-open="${CSS.escape(this.dataset.productId)}"]`));
        this.optionList.replaceChildren();
        options.forEach(option => {
          const input = option.querySelector('input[type="radio"]:checked, input[data-item="disclosure"]');
          const header = option.querySelector('.radios--header > span, .disclosure--label > span, .swatches--name');
          if (!input) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.guideOption = option.dataset.index;
          button.textContent = `${header?.textContent.trim() || input.dataset.optionName}: ${input.value}`;
          button.setAttribute('aria-pressed', String(option.dataset.index === this.activeOption));
          this.optionList.append(button);
          if (option.dataset.index === this.activeOption && this.compare) {
            const name = (input.dataset.optionName || '').toLowerCase();
            let value = input.value.trim();
            if (this.dataset.guideType === 'women' && /ital|itaalia/.test(name)) {
              const italy = ['36', '38', '40', '42', '44', '46', '48', '50'];
              const index = italy.indexOf(value);
              value = index < 0 ? '' : ['32', '34', '36', '38', '40', '42', '44', '46'][index];
            } else if (this.dataset.guideType === 'men' && /collar|neck/.test(name)) {
              const collar = ['39', '40', '41', '42', '43', '44', '45', '46'];
              const index = collar.indexOf(value);
              value = index < 0 ? '' : ['46', '48', '50', '52', '54', '56', '58', '60'][index];
            } else if (this.dataset.guideType === 'men') {
              const international = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'];
              const index = international.indexOf(value.toUpperCase());
              if (index >= 0) value = ['46', '48', '50', '52', '54', '56', '58', '60'][index];
            }
            this.compare.value = Array.from(this.compare.options).some(item => item.value === value) ? value : '';
          }
        });
        this.querySelector('.size-guide__selection').hidden = !this.optionList.children.length;
      }
      showTab(name) {
        this.tabs.forEach(tab => {
          const active = tab.dataset.guideTab === name;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.querySelectorAll('[data-guide-panel]').forEach(panel => panel.hidden = panel.dataset.guidePanel !== name);
      }
      setUnit(unit) {
        this.querySelectorAll('[data-cm]').forEach(cell => cell.textContent = cell.dataset[unit]);
        this.querySelectorAll('[data-guide-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideUnit === unit)));
        this.querySelector('[data-guide-unit-label]').textContent = this.querySelector(`[data-guide-unit="${unit}"]`).textContent;
        this.querySelector('[data-guide-inch-note]').hidden = unit !== 'in';
      }
      highlight(value) {
        this.querySelectorAll('[data-guide-size]').forEach(cell => cell.dataset.guideSelected = String(cell.dataset.guideSize === value && value !== ''));
        const status = this.querySelector('[data-guide-status]');
        if (status) status.textContent = value ? status.dataset.message.replace('[size]', value) : status.dataset.defaultMessage;
        this.querySelectorAll('[data-size-guide-table]').forEach(scroller => {
          const selected = scroller.querySelector('thead [data-guide-selected="true"]');
          if (!selected || !scroller.clientWidth) return;
          const labelWidth = scroller.querySelector('th').getBoundingClientRect().width;
          const offset = selected.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft - labelWidth;
          scroller.scrollLeft = Math.max(0, offset);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["utility-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('utility-navigation')) customElements.define('utility-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController(); const signal = this.controller.signal;
      const initialize = () => {
        const root = this.closest('.utility-page') || this.closest('main').querySelector('.shopify-policy__container');
        if (!root) return;
        if (!root.id) root.id = 'utility-top';
        if (this.parentElement !== root) root.append(this);
        const body = root.querySelector('.utility-page__content, .shopify-policy__body');
        const headings = Array.from(body.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong')).filter(heading => {
          if (heading.closest('form, [style*="display: none"]')) return false;
          const text = heading.textContent.trim();
          if (heading.matches('strong') && heading.parentElement.matches('p') && heading.parentElement.textContent.trim() === text) return false;
          return heading.matches('h1, h2, h3, h4, h5, h6') || ((/^SECTION\s+\d+/i.test(text) || text === 'OVERVIEW') && text.length < 120);
        });
        if (headings.length < 2) return;
        const nav = this.querySelector('.utility-navigation__toc'); const disclosure = document.createElement('details'); disclosure.open = matchMedia('(min-width: 901px)').matches; const title = document.createElement('summary'); title.textContent = this.dataset.heading;
        const list = document.createElement('ol');
        headings.forEach((heading, index) => { if (!heading.id) heading.id = `information-section-${index + 1}`; const row = document.createElement('li'); const link = document.createElement('a'); link.href = `#${heading.id}`; link.textContent = heading.textContent.trim(); row.append(link); list.append(row); });
        disclosure.append(title, list); nav.replaceChildren(disclosure); nav.hidden = false;
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true, signal }); else initialize();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
  } catch(e) { console.error(e); }
})();

})();
